import Typography from "@portal/components/atoms/v2/typography";
import { MainBox } from "../components/mainBox";
import { IPageProps } from "@portal/types/robot/IPageProps";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { useRobot } from "@portal/app/context/robotProvider";
import { SelectionBoxComponent } from "../components/selectionBox/SelectionBoxComponent";
import { RobotFooterComponent } from "../components/footer";
import { RefreshInfo } from "./info";
import { TextLine } from "@portal/components/atoms/v2/textLine";
import { SendMessageForResize } from "@portal/app/(iframe)/helpers/sendMessageForResize";

export const RefreshPage = ({ centerId, pageIndex, isDefaultLanguage }: IPageProps) => {
  const { riskLevelRequest: request, setNeedMoreInfo } = useRobot();
  const isButtonDisabled = request.needMoreInfo === null;
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const options = [texts.PAGE_3_A, texts.PAGE_3_B];
  const showToggleBox = GetOption(request.needMoreInfo) === 1;

  const OnSelectionClick = (selectedOption: number) => {
    const result = selectedOption === 0 ? false : true;
    setNeedMoreInfo(result);
    SendMessageForResize("sparerobot", "sparerobot");
  };

  return (
    <>
      <MainBox>
        <Typography variant="H6">{texts.PAGE_3_SUBHEADER}</Typography>
        <TextLine />
        <SelectionBoxComponent
          options={options}
          selectedOption={GetOption(request.needMoreInfo) ?? -1}
          onSelectionClick={OnSelectionClick}
        />
        {showToggleBox && <RefreshInfo isDefaultLanguage={isDefaultLanguage} />}
      </MainBox>
      <RobotFooterComponent
        pageIndex={pageIndex}
        centerId={centerId}
        primaryButtonText={texts.BUTTON_NEXT}
        secondaryButtonText={texts.BUTTON_BACK}
        disabled={isButtonDisabled}
      />
    </>
  );
};

export const GetOption = (needMoreInfo: boolean | null) => {
  if (needMoreInfo === null) return null;
  return needMoreInfo ? 1 : 0;
};
